import PropTypes from 'prop-types'

export const FilterResultsShape = PropTypes.shape({
  active_segment: PropTypes.object,
  active_designations: PropTypes.object.isRequired,
  active_category_ids: PropTypes.object,
  all_categories: PropTypes.array,
  all_designations: PropTypes.array.isRequired,
  commodity_code_families: PropTypes.array.isRequired,
  commodity_code_family_count: PropTypes.object.isRequired,
  commodity_code_segments: PropTypes.object.isRequired,
  commodity_code_segment_count: PropTypes.object.isRequired,
  designations_by_state: PropTypes.object.isRequired,
  rating_counts: PropTypes.object.isRequired
})
